<template>
  <header class="page-header publication-header">
    <BranchShape v-scroll:reveal="{ delay: 75 }" class="layout-cta__branch" color="white" :opacity="0.4" header />

    <section class="page-header__container">
      <BreadCrumbs />

      <h1 v-if="publication" v-scroll:reveal="{ delay: 50 }" class="publication-header__banner">
        {{ publication.title }}
      </h1>

      <div v-if="publication" class="publication-header__meta">
        <section class="publication-header__submeta">
          <span v-scroll:reveal="{ delay: 200 }" class="publication-header__data">
            <SvgIcon id="content-date" />
            <p>{{ formattedDate }}</p>
          </span>

          <span v-scroll:reveal="{ delay: 225 }" class="publication-header__data -small-icon">
            <SvgIcon id="author" />
            <p>{{ authors }}</p>
          </span>
        </section>
      </div>
    </section>
  </header>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ResourcesMonitoringSingleHeader',
  props: {
    publication: {
      type: Object,
      default: null
    }
  },
  computed: {
    authors() {
      return this.publication && this.publication.authors
        ? this.publication.authors
            .map(authorId => this.$wp.authorsById[authorId].name)
            .filter(Boolean)
            .join(', ')
        : null
    },
    formattedDate() {
      return this.publication ? moment(this.publication.original_publish_date).format('D MMMM YYYY') : null
    }
  }
}
</script>
